import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
// import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
// import ListingExperiencesPage from "containers/ListingExperiencesPage/ListingExperiencesPage";
// import ListingExperiencesMapPage from "containers/ListingExperiencesPage/ListingExperiencesMapPage";
import ListingStayDetailPage from "containers/ListingDetailPage/ListingStayDetailPage";
import ListingExperiencesDetailPage from "containers/ListingDetailPage/ListingExperiencesDetailPage";
// import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
// import ListingCarMapPage from "containers/ListingCarPage/ListingCarMapPage";
// import ListingCarDetailPage from "containers/ListingDetailPage/ListingCarDetailPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
// import CarCheckOutPage from "containers/CheckOutPage/CarCheckOutPage";
import PayPage from "containers/PayPage/PayPage";
// import AuthorPage from "containers/AuthorPage/AuthorPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
// import AccountSavelists from "containers/AccountPage/AccountSavelists";
// import AccountBilling from "containers/AccountPage/AccountBilling";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
// import PageSubcription from "containers/PageSubcription/PageSubcription";
// import BlogPage from "containers/BlogPage/BlogPage";
// import BlogSingle from "containers/BlogPage/BlogSingle";
// import PageAddListing1 from "containers/PageAddListing1/PageAddListing1";
// import PageAddListing2 from "containers/PageAddListing1/PageAddListing2";
// import PageAddListing3 from "containers/PageAddListing1/PageAddListing3";
// import PageAddListing4 from "containers/PageAddListing1/PageAddListing4";
// import PageAddListing5 from "containers/PageAddListing1/PageAddListing5";
// import PageAddListing6 from "containers/PageAddListing1/PageAddListing6";
// import PageAddListing7 from "containers/PageAddListing1/PageAddListing7";
// import PageAddListing8 from "containers/PageAddListing1/PageAddListing8";
// import PageAddListing9 from "containers/PageAddListing1/PageAddListing9";
// import PageAddListing10 from "containers/PageAddListing1/PageAddListing10";
// import PageHome2 from "containers/PageHome/PageHome2";
// import ListingRealEstateMapPage from "containers/ListingRealEstatePage/ListingRealEstateMapPage";
// import ListingRealEstatePage from "containers/ListingRealEstatePage/ListingRealEstatePage";
import SiteHeader from "containers/SiteHeader";
// import ListingFlightsPage from "containers/ListingFlightsPage/ListingFlightsPage";
import FooterNav from "components/FooterNav";
import FloatingButtons from "components/FloatingActionButtons/FloatingButtons";
import useWindowSize from "hooks/useWindowResize";
import Home from "containers/Website";
import Nearby from "containers/Nearby.js";
import Gallery from "containers/Gallery";
import RentalIncome from "containers/RentalIncome";
import { useDispatch } from "react-redux";
import { setAuth, setIsAdmin } from "features/auth";
import OrdersList from "containers/AdminPages/AdminBookings";
import UsersList from "containers/AdminPages/AdminUsers";
import OrdersAnalytics from "containers/AdminPages/AnalyticsPage";
import LeadsPage from "containers/AdminPages/LeadPage";
import CustomDatePicker from "containers/Test/test";
import BookingUnavailable from "containers/BookingUnavailable";
// import PageHome3 from "containers/PageHome/PageHome3";
// import Tests from "components/Tests";

export const pages = [
  // { path: "/", exact: true, component: PageHome },
  // { path: "/#", exact: true, component: PageHome },
  // { path: "/home-1-header-2", exact: true, component: PageHome },
  // { path: "/home-2", component: PageHome2 },
  // { path: "/home-3", component: PageHome3 },
  //
  { path: "/listing-stay", component: ListingStayPage },
  { path: "/home", component: ListingStayMapPage },
  { path: "/:listingId", component: ListingStayDetailPage },
  // { path: "/test", component: Tests },
  //
  // {
  //   path: "/listing-experiences",
  //   component: ListingExperiencesPage,
  // },
  // {
  //   path: "/listing-experiences-map",
  //   component: ListingExperiencesMapPage,
  // },
  {
    path: "/listing-experiences-detail",
    component: ListingExperiencesDetailPage,
  },
  // //
  // { path: "/listing-car", component: ListingCarPage },
  // { path: "/listing-car-map", component: ListingCarMapPage },
  // // { path: "/listing-car-detail", component: ListingCarDetailPage },
  // { path: "/cars/:carId", component: ListingCarDetailPage },

  // //
  // { path: "/listing-real-estate-map", component: ListingRealEstateMapPage },
  // { path: "/listing-real-estate", component: ListingRealEstatePage },
  // //
  {
    path: "/signout",
    component: function SignOut() {
      const navigate = useNavigate();
      const dispatch = useDispatch();
      useEffect(() => {
        dispatch(setAuth(null));
        dispatch(setIsAdmin(false));
        navigate("/login");
      }, []);
      return <div></div>;
    },
  },
  // //
  { path: "/checkout", component: BookingUnavailable },
  // { path: "/checkout", component: CheckOutPage },
  // { path: "/book/cars/:carId", component: CarCheckOutPage },

  { path: "/pay-done", component: PayPage },
  // //
  // { path: "/author", component: AuthorPage },
  { path: "/account", component: AccountPage },
  { path: "/account-password", component: AccountPass },
  { path: "/", component: Home },
  { path: "/nearby", component: Nearby },
  { path: "/gallery", component: Gallery },
  { path: "/rental-income", component: RentalIncome },
  // { path: "/account-savelists", component: AccountSavelists },
  // { path: "/account-billing", component: AccountBilling },
  // //
  // { path: "/blog", component: BlogPage },
  // { path: "/blog-single", component: BlogSingle },
  // //
  // // { path: "/add-listing-1", component: PageAddListing1 },
  // // { path: "/add-listing-2", component: PageAddListing2 },
  // // { path: "/add-listing-3", component: PageAddListing3 },
  // // { path: "/add-listing-4", component: PageAddListing4 },
  // // { path: "/add-listing-5", component: PageAddListing5 },
  // // { path: "/add-listing-6", component: PageAddListing6 },
  // // { path: "/add-listing-7", component: PageAddListing7 },
  // // { path: "/add-listing-8", component: PageAddListing8 },
  { path: "/test", component: BookingUnavailable },
  { path: "/admin/bookings", component: OrdersList },
  { path: "/admin/users", component: UsersList },
  { path: "/admin/analytics", component: OrdersAnalytics },
  { path: "/admin/leads", component: LeadsPage },
  // //
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  // { path: "/subscription", component: PageSubcription },
  //
];

const MyRoutes = () => {
  const WIN_WIDTH = useWindowSize().width || window.innerWidth;
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route element={<Page404 />} />
      </Routes>

      {WIN_WIDTH < 768 && <FooterNav />}
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
